module.exports = __webpack_public_path__ + "media/landing_page/apple-icon-17720670.svg";